import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDLabelText, FDStack,
} from '@facet-wealth/design';
import { CondensedListItem } from 'Packages/FacetDesign/Components/Experimental/CondensedListItem';
import {
  IS_ARCHIVED_QUERY_FIELD,
  THREAD_TYPE_QUERY_FIELD,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters';

const OtherThreadFilterGroup = ({
  resource, onChange, handleClose, showTitle,
}) => {
  return (
    <FDStack direction={'column'} spacing={2}>
      {showTitle ? <FDLabelText value={'Other Filters'} /> : null}
      <FDStack direction={'column'} spacing={1}>
        <CondensedListItem
          primaryText={resource.meta().field(IS_ARCHIVED_QUERY_FIELD).attr('prompt')}
          onClick={() => {
            onChange(!resource.isTruthy(IS_ARCHIVED_QUERY_FIELD), IS_ARCHIVED_QUERY_FIELD);
            handleClose();
          }}
        />
        { resource.meta().field(THREAD_TYPE_QUERY_FIELD).options().list()
          .map((option) => {
            const selected = resource.attr(THREAD_TYPE_QUERY_FIELD) === option.attr('id');
            return (
              <CondensedListItem
                key={option.attr('id')}
                primaryText={option.attr('prompt')}
                onClick={() => {
                  onChange(selected ? null : option.attr('id'), THREAD_TYPE_QUERY_FIELD);
                  handleClose();
                }}
                test={`thread-list-filter-${option.attr('id')}`}
              />
            );
          })}
      </FDStack>
    </FDStack>
  );
};

OtherThreadFilterGroup.defaultProps = {
  showTitle: false,
};

OtherThreadFilterGroup.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  handleClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  showTitle: PropTypes.bool,
};

export {
  OtherThreadFilterGroup,
};
